// extracted by mini-css-extract-plugin
export default {"section":"Showcase__section--27nGF","sectionResponsive":"Showcase__sectionResponsive--1-JWb","popularTitle":"Showcase__popularTitle--1phWy"};